export default {
  'menuBuilder.menus': '菜单',
  'menuBuilder.menuBuilder': '菜单编辑器',
  // path路径动作的翻译
  'menuBuilder.resourceAction.top.search': '搜索结果',
  'menuBuilder.resourceAction.contract.publish': '发布菜单',
  'menuBuilder.resourceAction.menu.edit': '菜单信息',
  'menuBuilder.resourceAction.meal.add': '添加新菜',
  'menuBuilder.resourceAction.meal.add_existing': '添加现有',
  'menuBuilder.resourceAction.meal.edit': '编辑菜品',

  'menuBuilder.column.dish': '菜品',
  'menuBuilder.column.menuAndCategory': '菜单 & 分类',
  'menuBuilder.column.display_color': '颜色',
  'menuBuilder.column.price': '价格',
  'menuBuilder.column.open_price': '开价菜',
  'menuBuilder.column.point_price': '积分价',
  'menuBuilder.column.member_price': '会员价',
  'menuBuilder.column.discount_exempt': '折扣',
  'menuBuilder.column.tax_exempt': '免税',
  'menuBuilder.column.tax_code': '税码 & 税率',
  'menuBuilder.column.tax_rate': '税率：',
  'menuBuilder.column.customization': '附加选项',
  'menuBuilder.column.code': '自定义码',
  'menuBuilder.column.name': '菜单名',
  'menuBuilder.column.foreign_name': '菜单中文名',
  'menuBuilder.column.available_time': '可用时间',
  'menuBuilder.column.specifal_time': '特殊时间',
  'menuBuilder.requiredStartTime': '开始时间必填',
  'menuBuilder.requiredEndTime': '结束时间必填',
  'menuBuilder.startTimeShouldBeEarlierThanEndTime': '开始时间必须早于结束时间',
  'menuBuilder.requriedSpecialDate': '日期必填',
  'menuBuilder.rowConflicts': '第{i}条设置与第{j}条设置时间冲突',
  'menuBuilder.menuHourConflicts': '当前的营业时间有重叠，请合并营业时间并重新设置。',
  'menuBuilder.maxHourSettingsPerDay': '一天最多可以添加{maxCount}个时间段。',
  'menuBuilder.same_as_businesshour': '同店铺营业时间',
  'menuBuilder.different_business_hours': '不同于店铺营业时间',

  'menuBuilder.segment.search': '搜索',
  'menuBuilder.segment.selected': '编辑已选菜品',

  'menuBuilder.action.sort': '排序',
  'menuBuilder.action.updateMultiple': '批量更新',
  'menuBuilder.action.updateMultiple.pricing': '价格',
  'menuBuilder.action.updateMultiple.memberPrice': '会员价',
  'menuBuilder.action.updateMultiple.discount': '折扣',
  'menuBuilder.action.updateMultiple.taxSettings': '税设置',
  'menuBuilder.action.updateMainImage': '上传主图',
  'menuBuilder.action.update3rdImage': '上传第三方图片',
  'menuBuilder.action.addMore': '添加更多',
  'menuBuilder.action.dishSorting': '菜品排序',
  'menuBuilder.action.editDish': '编辑菜品',
  'menuBuilder.action.setColor': '设置颜色',
  'menuBuilder.action.addTime': '添加时间',
  'menuBuilder.action.showDetail': '显示详情',
  'menuBuilder.action.close': '收起',
  'menuBuilder.action.dishSort': '菜品排序',
  'menuBuilder.action.showMore': '显示额外的 {count} 个',
  'menuBuilder.action.hideMore': '隐藏额外的 {count} 个',
  'menuBuilder.action.publishMenu': '发布菜单',

  'menuBuilder.allDaysClose': '全天关闭',
  'menuBuilder.guideText': '选择此菜单中的一个分类以开始管理菜品',
  'menuBuilder.searchPlaceholder': '查找已存在菜品',
  'menuBuilder.searchEmptyDescription': '搜索并选择您想要在此类别中添加的所有现有菜品。',
  'menuBuilder.selectedMealsReachedTheLimit':
    '您可以一次选择最多<span style="color: #ce2c54;font-size: 14px;font-family: PingFang SC;">{maxCount}个菜品</span>。请取消其他选择，然后重试。',
  'menuBuilder.searchMealsPlaceholder': '搜索菜品',

  'menuBuilder.section.dishInfo': '菜品信息',
  'menuBuilder.section.printers': '打印机',
  'menuBuilder.section.taxCode': '税码',
  'menuBuilder.selectedCategories': '已选择:',
  'menuBuilder.deleteMealPrompt': '确认要删除此菜品吗？',
  'menuBuilder.sortDish.title': '设置排序',
  'menuBuilder.sortBy.price': '价格',
  'menuBuilder.sortBy.alpha': '按字母排序',
  'menuBuilder.menuHourMode.always': '长期',
  'menuBuilder.menuHourMode.specific': '特定日期和时间',
  'menuBuilder.searchGuideText': '搜索并选择所有您想要添加到当前分类上的现有菜品。',
  'menuBuilder.emptyResultText': '没有与您的搜索匹配的项目',
  'menuBuilder.emptyResultGuide': '尝试更新或清除您的搜索以查找项目',
  'menuBuilder.loadMenuFailed': '加载失败，重试',
  'menuBuilder.noData': '无数据',
  'menuBuilder.customizationPickerDrawerTitle': '选择自定义选项',
  'menuBuilder.selectAll': '全选',
  'menuBuilder.customizationsDescription': `
    带<span style="color: #ce2c54;font-family: SimSun, sans-serif;margin: 0 4px;">*</span>的附加选项组表示，用户至少需要选择一个选项才能将此菜品加入购物车。如您想更改此设置，请前往附加选项页面.
  `,
  'menuBuilder.categoriesRequired': '请至少选择任意菜单的一个分类。',
  'menuBuilder.noMealItems': '让我们给当前菜单下的此分类添加一些菜品',
  'menuBuilder.pointsCategory': '积分菜',
  'menuBuilder.dishAdded': '已添加',
  'menuBuilder.successfullyCreated': '成功创建菜品',
  'menuBuilder.successfullyUpdated': '成功更新菜品',
  'menuBuilder.successfullyUpdatedMenu': '成功更新菜单信息',
  'memuBuilder.taxable': '征税',

  'menuBuilder.emptySearchResult': '没有菜品符合您的搜索条件。请更新您的搜索词以查找菜品。',
  'menuBuilder.tooManySearchResult':
    '您搜索的 “<span>{searchTerm}</span>” 返回了超过<span>50</span>个菜品。请细化您的搜索词以获得更具体的搜索结果。',
  'menuBuilder.emptySearchTerm': '请输入任何搜索词以查找菜品。',
  'menuBuilder.noCustomizations': '无附加选项',
  'menuBuilder.searchCustomizations': '搜索附加选项',
  'menuBuilder.searchCategories': '搜索分类',

  'menuBuilder.channelVisibility': '可见渠道',
  'menuBuilder.channelVisibility.description': '此菜单将在下列您选择展示的渠道上展示。',
  'menuBuilder.channel.qr': '扫码点餐',
  'menuBuilder.channel.kiosk': '自助点餐',
  'menuBuilder.channel.tablet': '平板点餐',

  // 合约简介
  'menuBuilder.contractDescription.pos':
    '这个板块内的菜单会与POS即时同步。服务员在POS的购物车页面内可以轻松便捷的修改订单内菜品，简化操作流程以及提高顾客的点餐体验！',
  'menuBuilder.contractDescription.smart_ordering':
    '这个板块内的菜单将应用在您店内的自助点餐设备上。顾客可以在设备上直接浏览菜品的所有信息，包括图片、描述、价格和定制选项，从而提供更加流畅和升级的店内用餐体验。',
  'menuBuilder.contractDescription.third_party':
    '此部分菜单会发布至您已集成的第三方外卖平台。您可以通过一个操作便捷的菜单编辑器轻松管理您的外卖平台菜单。所有的修改将在发布后自动同步至各个平台， 为您节省更多时间和成本！',
  'menuBuilder.contractDescription.white_label':
    '这个板块内的菜单与您的餐厅网站即时同步，确保顾客拿到一手的菜单内容。网站菜单页面经过全面优化后清晰展示所有菜单和菜品的详情介绍，操作便捷，为顾客提供丝滑的线上点餐体验。',

  // 合约未开启时的提示
  'menuBuilder.contractInactive.pos':
    '一款强大且操作简单的POS，简化了店内的服务流程，为您的餐厅打造一个高效的管理系统！',
  'menuBuilder.contractInactive.smart_ordering':
    '为您提供三种适用于不同场景的无接触点单方案，通过展示餐品图片和文字介绍来提高顾客的用餐体验！',
  'menuBuilder.contractInactive.third_party':
    '通过您的POS终端和商家后台来管理外卖平台的订单和菜单，无需额外管理平台平板，帮助您的店铺更好地降本增效！',
  'menuBuilder.contractInactive.white_label':
    '让顾客直接从您的餐厅网站下单，无需支付高额抽成费用，提高店铺在谷歌的曝光率，为您的店铺带来更多收益！',
  'menuBuilder.publishMenu.title': '菜单发布',
  'menuBuilder.publishMenu.description':
    '选择一个菜单并发布到对应的平台。您可以将同一菜单发布到多个或所有平台，但一个平台只能接受一本菜单。',
  'menuBuilder.publishHistory.title': '菜单发布记录',
  'menuBuilder.publishHistory.description':
    '通过选择平台查看对应平台的菜单发布记录。菜单发布可能需要几分钟才能在对应平台上完成，如果菜单发布到平台失败了，请查看对应记录提供的失败原因。',
  'menuBuilder.integratedDeliveryPlatforms': '已集成的外卖平台',
  'menuBuilder.menuCategory.title': '分类',
  'menuBuilder.menuCategory.dishCount': '菜品总数',
  'menuBuilder.menuCategory.underConstruction': '开发中',
  'menuBuilder.menuPublish.selectMenuPlaceholder': '请选择一本菜单',
  // 菜单发布记录
  'menuBuilder.publishHistory.column.date': '日期',
  'menuBuilder.publishHistory.column.platform': '平台',
  'menuBuilder.publishHistory.column.menu': '菜单',
  'menuBuilder.publishHistory.column.operator': '操作人',
  'menuBuilder.publishHistory.column.status': '状态',
  'menuBuilder.publishHistory.searchPlaceholder': '选择平台',
  'menuBuilder.publishMenuStatus.success': '完成',
  'menuBuilder.publishMenuStatus.failed': '失败',
  'menuBuilder.publishMenuStatus.in_progress': '进行中',
  // Online ordering 设置
  'menuBuilder.onlineOrderingSettings.delivery.title': '配送服务',
  'menuBuilder.onlineOrderingSettings.delivery.description':
    '无需支付高额的平台抽成，解锁该功能后你的餐厅网站也可以为顾客提供配送服务，为您的店铺带来更多盈利！',
  'menuBuilder.onlineOrderingSettings.pickup.title': '到店自取',
  'menuBuilder.onlineOrderingSettings.pickup.description':
    '顾客可以轻松的在您的网站上浏览菜单并提前下单，且选择方便的时间到店取餐，为顾客提供提供灵活的点餐体验！',
  'menuBuilder.onlineOrderingSettings.googleFoodOrdering.title': '谷歌点餐',
  'menuBuilder.onlineOrderingSettings.googleFoodOrdering.description':
    '谷歌点餐服务可以提高您的店铺在谷歌平台的曝光量，提高店铺流量和营业额，为您带来更多订单和收益！',
  'menuBuilder.loadChannelsFailed': '加载Delivery平台失败，点击重试',
  'menuBuilder.unbindChannels': '暂未设置任何平台',
};
